import { FilterFilled } from "@ant-design/icons";
import {
  buildFilters,
  getNumericValue,
  getTimeValue,
} from "../utils/eventFormatters";
import classes from "./RankingEventModal.module.scss";

const filterIcon = <FilterFilled className={classes.FilterIcon} />;

export const getRankingColumns = (rankingTableRows) => [
  {
    title: "",
    dataIndex: "position",
    key: "position",
    align: "center",
    width: "4%",
  },
  {
    title: "Jogos",
    dataIndex: "game",
    key: "game",
    width: "24%",
    filters: buildFilters(rankingTableRows, "game"),
    filterIcon,
    onFilter: (value, record) => record.game === value,
    sorter: (a, b) => a.game.localeCompare(b.game),
  },
  {
    title: "Participantes",
    dataIndex: "participants",
    key: "participants",
    width: "13%",
    sorter: (a, b) =>
      getNumericValue(a.participants) - getNumericValue(b.participants),
  },
  {
    title: "Total jogadas",
    dataIndex: "totalPlays",
    key: "totalPlays",
    width: "13%",
    sorter: (a, b) =>
      getNumericValue(a.totalPlays) - getNumericValue(b.totalPlays),
  },
  {
    title: "Total pontuação",
    dataIndex: "totalScore",
    key: "totalScore",
    width: "14%",
    sorter: (a, b) =>
      getNumericValue(a.totalScore) - getNumericValue(b.totalScore),
  },
  {
    title: "Tempo (hh:mm:ss)",
    dataIndex: "time",
    key: "time",
    width: "17%",
    sorter: (a, b) => getTimeValue(a.time) - getTimeValue(b.time),
  },
  {
    title: "XP",
    dataIndex: "xp",
    key: "xp",
    width: "15%",
    sorter: (a, b) => getNumericValue(a.xp) - getNumericValue(b.xp),
  },
];
